// import { Col, Form, Radio, Row } from 'antd';
// import { FormInstance } from 'antd/lib/form';
// import { useEffect } from 'react';

// type Props = { billingForm: FormInstance<any> };

// export default function
// InvPostIsDiscountIsPrevDue({ billingForm }: Props) {
//   // @HANDLE RADIO BUTTONS
//   useEffect(() => {
//     billingForm?.setFieldsValue({
//       invoice_show_prev_due: 0,
//       invoice_show_discount: 1,
//       invoice_partial_payment: 0,
//     });
//   }, []);

//   return (
//     <Row>
//       <Col span={6} xs={24} sm={24} md={24} lg={8}>
//         <Form.Item className='commonBox' name={['invoice_show_prev_due']} label='Show Prev Due'>
//           <Radio.Group>
//             <Radio value={1}>Yes</Radio>
//             <Radio value={0}>No</Radio>
//           </Radio.Group>
//         </Form.Item>
//       </Col>
//       <Col span={6} xs={24} sm={24} md={12} lg={8}>
//         <Form.Item
//           className='commonBox'
//           name={['invoice_show_discount']}
//           label='Show Discount'
//           // colon={false}
//         >
//           <Radio.Group>
//             <Radio value={1}>Yes</Radio>
//             <Radio value={0}>No</Radio>
//           </Radio.Group>
//         </Form.Item>
//       </Col>
//       <Col span={6} xs={24} sm={24} md={12} lg={8}>
//         <Form.Item
//           className='commonBox'
//           name={['invoice_partial_payment']}
//           label='Partial Payment'
//           // colon={false}
//         >
//           <Radio.Group>
//             <Radio value={1}>Yes</Radio>
//             <Radio value={0}>No</Radio>
//           </Radio.Group>
//         </Form.Item>
//       </Col>
//     </Row>
//   );
// }

import { Col, DatePicker, Form, Input, Radio, Row } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { FormInstance } from 'antd/lib/form';
import dayjs from 'dayjs';
import { useEffect } from 'react';

type Props = { billingForm: FormInstance<any>; clientPriceSum?: Number };

export default function InvPostIsDiscountIsPrevDue({ billingForm, clientPriceSum }: Props) {
  const clientPrice = Number(clientPriceSum) ? Number(clientPriceSum) * 0.3 : 0;

  // Watch the partial payment toggle, not the date
  const isPartialPayment = useWatch(['invoice_partial_payment'], billingForm);

  // Set initial form values
  useEffect(() => {
    billingForm?.setFieldsValue({
      invoice_show_prev_due: 0,
      invoice_show_discount: 1,
      invoice_partial_payment: 0,
      invoice_due_date: null,
      initial_payment_amount: clientPrice,
    });
  }, [billingForm, clientPrice]);
  const values = billingForm.getFieldsValue(true);
  // Keep initial_payment_amount updated when clientPriceSum changes
  useEffect(() => {
    billingForm?.setFieldsValue({
      initial_payment_amount: clientPrice,
    });
  }, [clientPrice, billingForm]);
  return (
    <Row gutter={[10, 10]}>
      <Col span={6} xs={24} sm={24} md={24} lg={8}>
        <Form.Item className='commonBox' name={['invoice_show_prev_due']} label='Show Prev Due'>
          <Radio.Group>
            <Radio value={1}>Yes</Radio>
            <Radio value={0}>No</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
      <Col span={6} xs={24} sm={24} md={12} lg={8}>
        <Form.Item className='commonBox' name={['invoice_show_discount']} label='Show Discount'>
          <Radio.Group>
            <Radio value={1}>Yes</Radio>
            <Radio value={0}>No</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col span={6} xs={24} sm={24} md={12} lg={8}>
        <Form.Item className='commonBox' name={['invoice_partial_payment']} label='Partial Payment'>
          <Radio.Group>
            <Radio value={1}>Yes</Radio>
            <Radio value={0}>No</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
      <Col
        span={6}
        xs={24}
        sm={24}
        md={12}
        lg={8}
        style={{ display: isPartialPayment === 1 ? 'block' : 'none' }}
      >
        <Form.Item
          name={['invoice_partial_payment_date']}
          label='Payment Date'
          initialValue={dayjs()}
          rules={[
            {
              required: isPartialPayment === 1,
              message: 'Date is required',
            },
          ]}
        >
          <DatePicker
            format='YYYY-MM-DD'
            disabledDate={(current) => current && current < dayjs().startOf('day')}
          />
        </Form.Item>
      </Col>
      <Col
        span={12}
        xs={24}
        sm={24}
        md={12}
        lg={12}
        style={{ display: isPartialPayment === 1 ? 'block' : 'none' }}
      >
        <Form.Item
          rules={[
            {
              required: isPartialPayment === 1,
              message: 'Payment Amount is required',
            },
          ]}
          name={['initial_payment_amount']}
          label='Initial Payment Amount:'
        >
          <Input type='number' placeholder='Enter Payment Amount' />
        </Form.Item>
      </Col>
    </Row>
  );
}
